export default {
  /**
   * 岗位管理
   */

  getPackageList:"/bygRole/find",
  getUnitType:"/bygRole/findType",
  getPmsList:"/bygRole/findRoleById",
  createEditPms:"/bygRole/addOrEdit"

}



// WEBPACK FOOTER //
// ./src/api/Permission/urls.js